'use client';

// eslint-disable-next-line no-useless-escape
var REGEXP_DDMMYYYY = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
// eslint-disable-next-line no-useless-escape
var REGEXP_MMYYYY = new RegExp(/^(0?[1-9]|1[012])[\/]((19|20)\d{2})$/); // format: DD/MM/YYYY
var REGEXP_YYYY = new RegExp(/^((19|20)\d{2})$/); // format: DD/MM/YYYY
var FIRST_MONTH = 0;
var FIRST_DAY = 1;
var defaultPlaceholder = {
    date: {
        en: 'DD/MM/YYYY',
        vi: 'Ngày/Tháng/Năm'
    },
    month: {
        en: 'MM/YYYY',
        vi: 'Tháng/Năm'
    },
    year: {
        en: 'YYYY',
        vi: 'Năm'
    }
};
var MAX_LENGTH_DATE_INPUT = 10;
var MAX_LENGTH_MONTH_INPUT = 7;
var MAX_LENGTH_YEAR_INPUT = 4;

export { FIRST_DAY, FIRST_MONTH, MAX_LENGTH_DATE_INPUT, MAX_LENGTH_MONTH_INPUT, MAX_LENGTH_YEAR_INPUT, REGEXP_DDMMYYYY, REGEXP_MMYYYY, REGEXP_YYYY, defaultPlaceholder };
//# sourceMappingURL=const.js.map
